import { useTranslation } from 'react-i18next'
import { useField } from 'formik'

import { FormikField } from '../../../../Formik'
import { SwitchInput } from '../../../../Switch'
import { NEWSBOARD_POST_FORM_FIELD_NAME_COMMENTS } from '../../NewsboardPostForm.constants'
import { getNewsboardCommentsSwitchLabelKey } from '../../NewsboardPostForm.utils'

function CommentsField() {
  const { t } = useTranslation()

  const [field] = useField(NEWSBOARD_POST_FORM_FIELD_NAME_COMMENTS)

  return (
    <FormikField
      Component={SwitchInput}
      fieldComponentProps={{
        label: `${t('Newsboard.FormCommentsFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      label={t(getNewsboardCommentsSwitchLabelKey(field.value))}
      name={NEWSBOARD_POST_FORM_FIELD_NAME_COMMENTS}
    />
  )
}

export default CommentsField
